import { axiosAzureInstance } from '../Utils/axios';
import type { AxiosResponse } from 'axios';

const API_BASE_URL = '/smscservice/api';
const TWINDOLPHIN_CUSTOMERS_URL = `${API_BASE_URL}/admin/twindolphin-customers`;

interface TwinDolphinCustomerPayload {
  tenantKey: string;
  dataset: string;
  label: string;
}

/**
 * Create a new TwinDolphin customer (SMSC client configuration).
 * @param {{ tenantKey: string, dataset: string, label: string }} payload
 * @returns {Promise<{ data: { id: number, tenantKey: string, dataset: string, label: string } }>}
 * @throws axios error with response.status 409 for conflict (tenant key already exists)
 */
function createTwinDolphinCustomer(payload: TwinDolphinCustomerPayload): Promise<AxiosResponse> {
  return axiosAzureInstance.post(TWINDOLPHIN_CUSTOMERS_URL, payload);
}

const SmartScanningProxyService = {
  createTwinDolphinCustomer,
};

export default SmartScanningProxyService;
